export function getTimeZone() {
  const metaTag = document.head.querySelector("meta[name=rails-tz]");

  return (metaTag ? metaTag.getAttribute("content") : null)
}